import { dwCollect } from '@/utils/dw-collect';

/**
 * dw 应用模板展示
 *
 */
export const dwOnAppTemplateShow = () => {
  dwCollect({ module: 'template', action: 'show' });
};

/**
 * dw 点击模板
 *
 * @param key1
 * @param key2
 */
export const dwOnAppTemplateClick = (key1 = '', key2 = '', from = '') => {
  dwCollect({ module: 'template', element: 'template', action: 'click', key1, key2, from });
};

/**
 * dw 点击【立即使用】
 *
 * @param key1
 * @param key2
 */
export const dwOnAppTemplateUseClick = (key1 = '', key2 = '') => {
  dwCollect({ module: 'template', element: 'use', action: 'click', key1, key2 });
};

/**
 * dw 模板详情弹窗展示
 *
 * @param key1
 * @param key2
 */
export const dwOnAppTemplateDetailShow = (key1 = '', key2 = '', from = '') => {
  dwCollect({ module: 'template', func: 'detail', action: 'show', key1, key2, from });
};

/**
 * dw 模板详情弹窗-点击【从模板创建应用】
 *
 * @param key1
 * @param key2
 */
export const dwOnAppTemplateDetailUseClick = (key1 = '', key2 = '', from = '') => {
  dwCollect({ module: 'template', func: 'detail', element: 'use', action: 'click', key1, key2, from });
};

/**
 * dw 点击【向我们反馈】
 *
 */
export const dwOnAppTemplateFeedbackClick = () => {
  dwCollect({ module: 'template', element: 'feedback', action: 'click' });
};

/**
 * dw 点击【反馈模板需求】
 *
 */
export const dwOnAppTemplateSearchFeedbackClick = () => {
  dwCollect({ module: 'template', func: 'search', element: 'feedback', action: 'click' });
};

/**
 * dw 咨询二维码曝光展示
 *
 */
export const dwOnQrCodeShow = (templateId: string, templateName: string) => {
  dwCollect({
    module: 'template',
    func: 'detail',
    element: 'qrcode',
    action: 'show',
    from: templateId,
    key2: templateName,
  });
};

/**
 * dw 单个模板展示
 */
export const dwOnSingleTemplateShow = (templateId: string, templateName: string, templateTypeName: string) => {
  dwCollect({
    module: 'template',
    func: 'template',
    action: 'show',
    from: templateId,
    key2: templateName,
    key1: templateTypeName,
  });
};

/**
 * dw 点击【从空白创建应用】
 */
export const dwOnCreateBlankApp = (typeName: string) => {
  dwCollect({
    element: 'new',
    action: 'click',
    key1: typeName,
  });
};

/**
 * dw 点击【从空白创建应用】
 */
export const dwOnCreateBlankAppSuccess = (typeName: string) => {
  dwCollect({
    element: 'new',
    action: 'success',
    key1: typeName,
  });
};
